
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { AppRoutingModule } from './app-routing.module';
import {MatSelectModule} from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import { MapsComponent } from './maps/maps.component';
import {MatStepperModule} from '@angular/material/stepper';
import { RegistrarComponent } from './registrar/registrar.component';
import { ReactiveFormsModule } from '@angular/forms';
import {NgxMaskModule, IConfig} from 'ngx-mask';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import {MatListModule} from '@angular/material/list';
import { NgxUiLoaderModule,NgxUiLoaderConfig } from  'ngx-ui-loader';
import { NgxLoadersCssModule } from 'ngx-loaders-css';
import { LayoutComponent } from './layout';
import { HttpClientModule,HTTP_INTERCEPTORS  } from '@angular/common/http';
import {Servicio} from '../app/servicio/servicio';
import {AlertService} from '../app/servicio/index';
import {AuthenticationService} from '../app/servicio/index';
import {UserService} from '../app/servicio/index';
import { UserIdleModule } from 'angular-user-idle';
import {NgbModule,NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { CerrarComponent } from './cerrar/cerrar.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ErrorComponent } from './error/error.component';
import {Var_menu} from './variable_globales/ver_menu';
import {MessagingService} from '../app/shared/messaging.service';
import { LOCALE_ID } from '@angular/core';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { RecuperarComponent } from './recuperar/recuperar.component';
import {MatBadgeModule} from '@angular/material/badge';
import { MomentModule } from 'ngx-moment';
const config: SocketIoConfig = { url: 'https://node.coopacsanmartin.pe', options: {} };
import {Info_operacion} from './variable_globales/info_operacion';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { RecaptchaModule } from "ng-recaptcha";
import {SnowComponent} from '../app/layout/layout/snow.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
//const config: SocketIoConfig = { url: 'http://localhost:8080', options: {} };
const APP_CONTAINERS = [
  LayoutComponent
];

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/es-PE';
import { LoginvotoComponent } from './loginvoto/loginvoto.component';
registerLocaleData(localeFr, 'es-PE');

import * as _moment from 'moment';
import { MatDateFormats, MAT_DATE_FORMATS, NativeDateAdapter, DateAdapter } from '@angular/material/core';
import{ MAT_DATE_LOCALE } from '@angular/material/core';
import { GestureConfig } from "../gesture-config";
import { LoginappComponent } from './loginapp/loginapp.component';
const MY_DATE_FORMATS = {
    parse: {
        dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' }
    },
    display: {
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
 };

export class AppDateAdapter extends NativeDateAdapter {

    format(date: Date, displayFormat: Object): string {
      //  if (displayFormat === 'input') {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        /*} else {
            return date.toDateString();
        }*/
    }
}
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  "bgsColor": "blue",
  "bgsOpacity": 0.5,
  "bgsPosition": "bottom-right",
  "bgsSize": 60,
  "bgsType": "ball-spin-clockwise",
  "blur": 5,
  "delay": 0,
  "fgsColor": "#ffffff",
  "fgsPosition": "center-center",
  "fgsSize": 60,
  "fgsType": "ball-scale-multiple",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 120,
  "logoUrl": "../assets/imagenes/purologo.png",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40, 40, 40, 0.8)",
  "pbColor": "#0d47a1",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "maxTime": -1,
  "minTime": 500
}

@NgModule({
  declarations: [
    RegistrarComponent,
    AppComponent,
    LoginComponent,

    MapsComponent,
    ...APP_CONTAINERS,
    CerrarComponent,
    ErrorComponent,
    RecuperarComponent,
    SnowComponent,
    LoginvotoComponent,
    LoginappComponent





  ],
  imports: [MatNativeDateModule,
    RecaptchaV3Module,
    RecaptchaModule,
    ScrollingModule,
    SocketIoModule.forRoot(config),
    MomentModule,
    MatBadgeModule,
    NgbModule,
    UserIdleModule.forRoot({idle: 90, timeout: 10, ping:60}),
    HttpClientModule,MatTooltipModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule,MatCheckboxModule,
    AppRoutingModule,
    MatSelectModule,
    MatSnackBarModule,
    MatListModule,MatSidenavModule,MatToolbarModule,
    MatSlideToggleModule,MatMenuModule,
    BrowserAnimationsModule,
    BrowserModule,MatProgressSpinnerModule,
    AppRoutingModule,
    NgxUiLoaderModule,
    NgxLoadersCssModule,
    MatCardModule,
    FormsModule,
    MatSelectModule,DeviceDetectorModule.forRoot(),
    MatInputModule,MatIconModule,MatStepperModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),

    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    MatDatepickerModule,
   // SocketIoModule.forRoot(config),

    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
   ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
   HammerModule,
  ],
  providers: [{provide: LOCALE_ID, useValue: 'es-PE' },
  {provide: DateAdapter, useClass: AppDateAdapter},
  //{provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
  //{provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
  //{ provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LcwpewoAAAAALRYPF7bsssYYQTooqpixVPWSSad' },
  { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LfkWtsqAAAAADERqmYaZQykjdTUWdiEvtTgKB6H' },

  Servicio,AlertService,AuthenticationService,UserService,NgbActiveModal,Var_menu,MessagingService,Info_operacion, { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig }],
  bootstrap: [AppComponent]
})
export class AppModule { }
